import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=bbcebe68&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=bbcebe68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcebe68",
  null
  
)

component.options.__file = "src/demo/pages/mall/activity.vue"
export default component.exports